import { render } from "./RelabelInFilterJobsButton.vue?vue&type=template&id=1f8b0feb&scoped=true"
import script from "./RelabelInFilterJobsButton.vue?vue&type=script&lang=js"
export * from "./RelabelInFilterJobsButton.vue?vue&type=script&lang=js"

import "./RelabelInFilterJobsButton.vue?vue&type=style&index=0&id=1f8b0feb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8b0feb"]])

export default __exports__